export const Hero = () => (
  <section className="home-hero" data-testid="hero-section">
    <picture>
      <source srcSet="/img/hero-mobile.webp" media="(max-width: 720px)" />
      <img
        src="/img/hero.webp"
        alt="Técnico da Desentope Maresias com van equipada em praia do litoral de São Paulo"
        fetchpriority="high"
      />
    </picture>
  </section>
);
